import React, { useEffect, useMemo, useRef, useState } from "react";
import "./TaskManager.css";
import { Link } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import moment from "moment";
import { useLanguage } from "../../Providers/LanguageContext";
import { FaEye } from "react-icons/fa"; // Import the eye icon
import './ProjectPopUp.css';
import Select from 'react-select'; // Import react-select
import { reactLocalStorage } from "reactjs-localstorage";
import { formatDateForInput } from "../../utils/convertDateToTimezone";

function ProjectPopUp({ closemodal, detailData, getProjecData }) {
  const { language } = useLanguage();
  const [showBudgetModal, setShowBudgetModal] = useState(false);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showEventModal, setShowEventModal] = useState(false);
  const [allUser, setAllUser] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]); // Changed to array for multi-select
  const [formData, setFormData] = useState({
    assignToUser: [],
    projectStatus: '',
  });
  const [userType, setUserType] = useState('');

  useEffect(() => {
    if (reactLocalStorage.getObject("userData")) {
      setUserType(reactLocalStorage.getObject("userData")?.userType);
    }
  }, [reactLocalStorage.getObject("userData")]);

  const fetchAllUsers = async () => {
    try {
      const response = await HttpClient.requestData("getUser", "GET");
      if (response && response?.status) {
        setAllUser(response?.data);
      } else {
        // toast.error(response?.message || 'Something went wrong!!!');
        setAllUser([]);
      }
    } catch (error) {
      // toast.error(error?.message || 'Something went wrong!!!');
      setAllUser([]);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      projectStatus: detailData?.projectStatus || '',
    }));
  }, [detailData?.projectStatus]);

  useEffect(() => {
    // Initialize selected users from detailData
    if (detailData?.assignToUser && detailData.assignToUser.length > 0) {
      // Convert assignToUser array to react-select format
      const userOptions = detailData.assignToUser.map(user => ({
        value: user._id,
        label: user.name
      }));
      setSelectedUsers(userOptions);
    }
  }, [detailData, allUser]);

  // Convert users to react-select options
  const userOptions = useMemo(() => {
    return allUser.map(user => ({
      value: user._id,
      label: user.name
    }));
  }, [allUser]);
  // console.log("detailDataprojj", detailData)

  const handleSelectStatus = async (e) => {
    // if (!e.target.value) return
    e.preventDefault();
    const data = {
      projectStatus: formData.projectStatus || 'open',
      assignToUser: selectedUsers?.length > 0 ? selectedUsers.map(user => user.value) : [],
    }
    const res = await HttpClient.requestData("update-project-eventDetails/" + detailData?._id, "PUT", data);
    if (res && res?.status) {
      closemodal();
      getProjecData();
      toast.success("Status Updated Sucessfully");
    }
  };

  console.log('detailData in project modal: ', detailData);

  const toggleBudgetModal = () => {
    setShowBudgetModal(!showBudgetModal);
  };

  const toggleTaskModal = () => setShowTaskModal(!showTaskModal);

  const toggleEventModal = () => setShowEventModal(!showEventModal);

  const projectref = useRef();
  const budgetDetailsRef = useRef();
  const taskDetailsRef = useRef();
  const eventDetailsRef = useRef();

  useEffect(() => {
    const HandleCLickOutside = (e) => {
      if (projectref.current && !projectref.current.contains(e.target)) {
        closemodal(false);
      }

    }
    document.addEventListener('mousedown', HandleCLickOutside)
  }, []);


  useEffect(() => {
    const HandleCLickOutside = (e) => {
      if (budgetDetailsRef.current && !budgetDetailsRef.current.contains(e.target)) {
        toggleBudgetModal();
      }

    }
    document.addEventListener('mousedown', HandleCLickOutside);
  }, []);

  useEffect(() => {
    const HandleCLickOutside = (e) => {
      if (taskDetailsRef.current && !taskDetailsRef.current.contains(e.target)) {
        toggleTaskModal();
      }

    }
    document.addEventListener('mousedown', HandleCLickOutside);
  }, []);

  useEffect(() => {
    const HandleCLickOutside = (e) => {
      if (eventDetailsRef.current && !eventDetailsRef.current.contains(e.target)) {
        toggleEventModal();
      }

    }
    document.addEventListener('mousedown', HandleCLickOutside);
  }, []);

  // console.log("selectedUsers: ", selectedUsers);

  return (
    <section className="taskPopSection">
      <div className="taskInPopDiv" ref={projectref}>
        <p className="taskModHead" style={{ textAlign: 'center' }}>
          Project
        </p>
        <div className="taskInScrollDiv">
          <div className="taskInScrollDiv">
            <div className="taskInScrollDiv">
              <div className="mb-2">
                {detailData?.projectName && <p className="dryClnDropText">{detailData?.projectName}</p>}
                {detailData?.startDate && detailData?.endDate && (
                  <p className="taskDtDetail">
                    {moment(detailData?.startDate).format('DD-MM-YYYY')} {` to `}
                    {moment(detailData?.endDate).format('DD-MM-YYYY')}
                  </p>
                )}
                {detailData?.startTime && detailData?.endTime && (
                  <p className="taskTimeDetail">
                    {moment(detailData?.startTime, ['HH:mm']).format('hh:mm a')} -{' '}
                    {moment(detailData?.endTime, ['HH:mm']).format('hh:mm a')}
                  </p>
                )}
                {detailData?.projectStatus && <div className="taskNoteSmallHead d-flex justify-content-start align-items-center">
                  <p className="taskNoteSmallHead" style={{
                    width: '150px'
                  }}>Status: {detailData?.projectStatus}</p>
                  <div style={{
                    display: 'inline-block',
                  }}>
                    <select
                      id=""
                      className="taskUpperInp"
                      name="taskStatus"
                      value={formData?.projectStatus}
                      onChange={(e) => {
                        setFormData(prev => ({
                          ...prev,
                          projectStatus: e.target.value,
                        }));
                      }}
                    >
                      <option value="" disabled selected>
                        {language.task_select}
                      </option>
                      <option value="open">{language.open}</option>
                      <option value="doing">{language.doing}</option>
                      <option value="done">{language.done}</option>
                      <option value="ideas">{language.ideas}</option>
                      <option value="onhold">{language.on_hold}</option>
                    </select>
                  </div>
                </div>}
                <div className="taskNoteTextDiv">
                  {detailData?.projectNotes && (
                    <>
                      <p className="taskNoteSmallHead">Project Notes: {detailData?.projectNotes}</p>
                      {/* <p className="taskNoteText">{detailData?.taskNotes}</p> */}
                    </>
                  )}

                  {detailData?.assignToUser
                    ?
                    <div className="taskNoteSmallHead d-flex justify-content-start align-items-center">
                      <p className="taskNoteSmallHead" style={{
                        width: '150px'
                      }}>Assign User:</p>
                      <div style={{
                        display: 'inline-block',
                        width: '100%',
                        maxWidth: '300px',
                      }}>
                        <Select
                          isMulti={true}
                          options={userOptions}
                          value={selectedUsers}
                          onChange={(selectedOptions) => {
                            setSelectedUsers(selectedOptions || []);
                          }}
                          placeholder="Select users..."
                          className="taskUpperInpSearch"
                        />
                      </div>
                    </div>
                    :
                    <p className="taskNoteSmallHead">Assign User: {language.not_assigned}</p>
                  }
                </div>
                {detailData?.linkedUser && <p className="taskNoteSmallHead">Linked User: {detailData?.linkedUser}</p>}
                {detailData?.linkedTask && <p className="taskNoteSmallHead">Linked Task: {detailData?.linkedTask}</p>}
                {detailData?.clientName && <p className="taskNoteSmallHead">Client Name: {detailData?.clientName}</p>}
                {detailData?.clientEmail && <p className="taskNoteSmallHead">Client Email: {detailData?.clientEmail}</p>}
                {detailData?.budget && <p className="taskNoteSmallHead">Total Budget: {detailData?.budget}</p>}
                {detailData?.nowbudget && <p className="taskNoteSmallHead">Budget as of now: {detailData?.nowbudget}</p>}
                {detailData?.currency && <p className="taskNoteSmallHead">Currency: {detailData?.currency}</p>}
                {detailData?.language && <p className="taskNoteSmallHead">Language: {detailData?.language}</p>}
                {detailData?.budgetDetails && userType !== "client" && (
                  <p className="taskNoteSmallHead" onClick={toggleBudgetModal} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    Budget Details: <FaEye style={{ cursor: 'pointer' }} />
                  </p>
                )}
                {detailData?.tasks && (
                  <p className="taskNoteSmallHead" onClick={toggleTaskModal} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    All Tasks Details: <FaEye style={{ cursor: 'pointer' }} />
                  </p>
                )}
                {detailData?.events && (
                  <p className="taskNoteSmallHead" onClick={toggleEventModal} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    All Events Details: <FaEye style={{ cursor: 'pointer' }} />
                  </p>
                )}
              </div>
            </div>

          </div>
        </div>
        <div className="tskSaveAsBtnDiv">
          <button className="tskSaveAsBtn" onClick={handleSelectStatus}>
            Save as Done
          </button>
        </div>
        <button className="closeTaskModBtn" onClick={() => closemodal()}>
          <i class="fa-solid fa-x"></i>
        </button>



        {/* Budget Details Modal */}
        {showBudgetModal && (
          <div className="modal-overlay" ref={budgetDetailsRef} onClick={(e) => e.stopPropagation()}>
            <div className="budget-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Budget Breakdown</h3>
                <button className="close-modal" onClick={(e) => {
                  e.stopPropagation();
                  toggleBudgetModal();
                }}>
                  <i className="fa-solid fa-x"></i>
                </button>
              </div>
              <div className="table-container">
                <table className="budget-table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Amount</th>
                      <th>My Profit</th>
                      <th>To Be Used</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailData?.budgetDetails?.length > 0 ? detailData?.budgetDetails?.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.title || '-'}</td>
                        <td>{item?.amount || '-'}</td>
                        <td>{item?.myProfit || '-'}</td>
                        <td>{item?.toBeUsed || '-'}</td>
                        <td>{item?.notes || '-'}</td>
                      </tr>
                    )) : (<tr>
                      <td colSpan={5}>No Budget Details Data Found ...</td>
                    </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}



        {/* All Task Details Modal */}
        {showTaskModal && (
          <div className="modal-overlay" ref={taskDetailsRef} onClick={(e) => e.stopPropagation()}>
            <div className="budget-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Tasks Breakdown</h3>
                <button className="close-modal" onClick={(e) => {
                  e.stopPropagation();
                  toggleTaskModal();
                }}>
                  <i className="fa-solid fa-x"></i>
                </button>
              </div>
              <div className="table-container">
                <table className="budget-table">
                  <thead>
                    <tr>
                      <th>Task Name</th>
                      <th>Task Notes</th>
                      <th>Task Status</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailData?.tasks?.length > 0 ? detailData?.tasks?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.taskName || '-'}</td>
                        <td>{item.taskNotes || '-'}</td>
                        <td>{item.taskStatus || '-'}</td>
                        <td>{item.selectDate ? item?.selectDate?.split('T')?.[0] : '-'}</td>
                        <td>{item.endDate ? item?.endDate?.split('T')?.[0] : '-'}</td>
                        <td>{item.startTime || '-'}</td>
                        <td>{item.endTime || '-'}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={7}>No Tasks Data Found ...</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}



        {/* All Events Details Modal */}
        {showEventModal && (
          <div className="modal-overlay" ref={eventDetailsRef} onClick={(e) => e.stopPropagation()}>
            <div className="budget-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Events Breakdown</h3>
                <button className="close-modal" onClick={(e) => {
                  e.stopPropagation();
                  toggleEventModal();
                }}>
                  <i className="fa-solid fa-x"></i>
                </button>
              </div>
              <div className="table-container">
                <table className="budget-table">
                  <thead>
                    <tr>
                      <th>Event Name</th>
                      <th>Event Status</th>
                      <th>Event Date</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailData?.events?.length > 0 ? detailData?.events?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.eventName || '-'}</td>
                        <td>{item.eventStatus || '-'}</td>
                        <td>{item.selectDate ? item?.selectDate?.split('T')?.[0] : '-'}</td>
                        <td>{item.startTime || '-'}</td>
                        <td>{item.endTime || '-'}</td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={7}>No Events Data Found ...</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default ProjectPopUp;
